import { VehicleInventory } from "../types/VehicleInventory.types";
import { FleetManagementRow } from "../types/FleetManagement-row.types";
import { FleetManagementPermissions } from "../types/FleetManagement.types";
import { LocationInventory } from "../../../features/FloorManager/typings/location-inventory";

/**
 * Maps backend VehicleInventory DTO to frontend FleetManagementRow
 * Handles location mapping and defaults extra fields that come from other endpoints
 */
export function mapVehicleInventoryToFleetManagementRow(
  vehicle: VehicleInventory
): FleetManagementRow {
  // Map locationInventory → location (Partial<LocationInventory>)
  let location: Partial<LocationInventory> | undefined;
  if (vehicle.locationInventory) {
    location = {
      id: vehicle.locationInventory.id,
      name: vehicle.locationInventory.name,
      address1: vehicle.locationInventory.address1
    };
  } else if (vehicle.locationInventoryId) {
    location = { id: vehicle.locationInventoryId };
  }

  // Map fleet permissions: use first entry from backend array, or a safe empty object
  const fleetPermissions: FleetManagementPermissions = vehicle.fleetPermissions?.[0] ?? {
    activeWeekdays: [],
    companies: [],
    costCenterUnits: [],
    users: [],
    ownerId: null
  };

  return {
    id: vehicle.id,
    name: vehicle.name,
    description: vehicle.description,
    picturePaths: vehicle.picturePaths.length > 0 ? vehicle.picturePaths : null,
    licensePlate: vehicle.licensePlate,
    brandModel: vehicle.brandModel,
    vehicleType: vehicle.vehicleType,
    fuel: vehicle.fuel,
    reach: vehicle.reach,
    numSeats: vehicle.numSeats,
    properties: vehicle.properties,
    pricePerHour: vehicle.pricePerHour ?? null,
    bufferMinutes: vehicle.bufferMinutes ?? null,
    location,
    companyId: vehicle.companyId ?? null,
    companyName: vehicle.companyName ?? null,
    status: vehicle.status,
    odometer: vehicle.odometer,
    adminNotes: vehicle.adminNotes ?? null,
    userNotes: vehicle.userNotes ?? null,
    contractDetails: vehicle.contractDetails,
    fleetPermissions,
    affectedCompanies: vehicle.fleetPermissions?.[0]?.companies?.map(c => String(c.id)) ?? [],
    affectedDepartments:
      vehicle.fleetPermissions?.[0]?.costCenterUnits?.map(u => String(u.id)) ?? [],
    affectedUsers: vehicle.fleetPermissions?.[0]?.users?.map(u => String(u.id)) ?? [],
    occupiedBooking: vehicle.occupiedBooking,
    blockedEvents: vehicle.blockedEvents,
    blockedReason: vehicle.blockedReason ?? null,
    attachments: vehicle.attachments
  };
}
